// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "main." + "b05b10d1c4df00303567" + ".css";
};